import script from "./PageHouse.vue?vue&type=script&setup=true&lang=js"
export * from "./PageHouse.vue?vue&type=script&setup=true&lang=js"

import "./PageHouse.vue?vue&type=style&index=0&id=e86aa988&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e86aa988"]])

export default __exports__